export default {
  [['html', 'body', '#root'].join(',')]: {
    backgroundColor: '#EDEFF0',
    height: '100%',
  },
  body: {
    fontFamily: 'Geologica, sans-serif',
  },
};
